import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TbsButtonDirective } from '@ngx-terabase/ui/button';
import { TbsDialogComponent, TbsDialogHeaderComponent } from '@ngx-terabase/ui/dialog';

@Component({
  selector: 'error-response-dialog',
  templateUrl: './error-response-dialog.component.html',
  styleUrls: ['./error-response-dialog.component.scss'],
  imports: [MatDialogModule, TbsDialogComponent, TbsDialogHeaderComponent, TbsButtonDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorResponseDialogComponent {
  private dialogRef: MatDialogRef<ErrorResponseDialogComponent> = inject(MatDialogRef<ErrorResponseDialogComponent>);

  public refresh(): void {
    window.location.reload();
  }

  public close(): void {
    this.dialogRef.close();
  }
}
